import { PropsWithChildren, ReactElement, ReactNode, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { PaloNotFound } from './palo-not-found';
import { resetResourceMissing } from '../../reducers/resource-missing-reducer';
import { useAppSelector } from '../../../store/use-appstate-selector';

export interface PaloResourceGuardProps {
    /** Shown when the record behind the address does not exist. */
    title: ReactNode;
    backTo: string;
    backLabel: ReactNode;
}

/**
 * Puts a way back where a mask would otherwise stand empty.
 *
 * The masks fetch their record themselves; when that comes back as missing the
 * fetch says so, and this shows it instead of the empty mask. The mark is
 * dropped on the way to the next address, so a working record is never hidden
 * by the one before it.
 */
export const PaloResourceGuard = ({
    title,
    backTo,
    backLabel,
    children,
}: PropsWithChildren<PaloResourceGuardProps>): ReactElement => {
    const missing = useAppSelector(state => state.resourceMissing);
    const dispatch = useDispatch();
    const { pathname } = useLocation();

    useEffect(() => {
        dispatch(resetResourceMissing());
    }, [dispatch, pathname]);

    return missing ? <PaloNotFound title={title} backTo={backTo} backLabel={backLabel} /> : <>{children}</>;
};
